"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const xstate_1 = require("../../lib/constants/xstate");
const ErrorPage_1 = __importDefault(require("../../../components/ErrorPage/ErrorPage"));
const messages_1 = __importDefault(require("../../lib/messages"));
const Confirmation_1 = __importDefault(require("../ConfirmationPage/Confirmation"));
const CancelPage_1 = __importDefault(require("../CancelPage"));
const utils_1 = require("../../lib/utils");
const react_2 = require("@xstate/react");
const styles_1 = require("./styles");
const SwitchByState = ({ service, matches }) => {
    const [state] = (0, react_2.useService)(service);
    if (matches(xstate_1.states.canceledPreviously)) {
        return (react_1.default.createElement(styles_1.StyledContainer, null,
            react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.previouslyCanceledPageHeading })));
    }
    if (matches(xstate_1.states.appointmentMissed)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.appointmentMissed });
    }
    if (matches(xstate_1.states.confirmationPage)) {
        return react_1.default.createElement(Confirmation_1.default, { service: service });
    }
    if ((0, utils_1.subStateMatchHelper)(xstate_1.states.cancelDisabledPage, state)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.cancelationDisabledBanner });
    }
    if ((0, utils_1.subStateMatchHelper)(xstate_1.states.cancelExpiredPage, state)) {
        return react_1.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.cancelationExpiredBanner });
    }
    if (matches(xstate_1.states.cancelPage)) {
        return react_1.default.createElement(CancelPage_1.default, { service: service });
    }
    return null;
};
exports.default = SwitchByState;
//# sourceMappingURL=SwitchByState.js.map